/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBlock8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm2.314-2.674a2.667 2.667 0 0 0-3.64-3.64l3.64 3.64Zm-.99.99-3.64-3.64a2.667 2.667 0 0 0 3.64 3.64Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlock12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M6 12A6 6 0 1 1 6 0a6 6 0 0 1 0 12Zm3.668-3.393a4.5 4.5 0 0 0-6.275-6.275l6.275 6.275Zm-1.06 1.061L2.331 3.393a4.5 4.5 0 0 0 6.275 6.275Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlock16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16Zm4.89-4.524A6 6 0 0 0 4.524 3.11l8.368 8.368Zm-1.414 1.415L3.11 4.523a6 6 0 0 0 8.367 8.367Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlock24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm6.32-5.094L7.094 5.68A8 8 0 0 1 18.32 16.905Zm-1.414 1.414A8 8 0 0 1 5.68 7.095L16.906 18.32Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconBlock = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlock(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconBlock8 {...iconProps} />;
        case '12':
            return <IconBlock12 {...iconProps} />;
        case '16':
            return <IconBlock16 {...iconProps} />;
        case '24':
            return <IconBlock24 {...iconProps} />;
        default:
            return <IconBlock24 {...iconProps} />;
    }
});
